import React from 'react';
import { Award, Users, Clock, CheckCircle } from 'lucide-react';
import { FadeIn, ScaleIn } from './ScrollReveal';

const About = () => {
  const stats = [
    {
      icon: Award,
      number: '20+',
      label: 'Jahre Erfahrung',
      description: 'Langjährige Expertise im Fliesenleger-Handwerk'
    },
    {
      icon: Users,
      number: '500+',
      label: 'Zufriedene Kunden',
      description: 'Erfolgreiche Projekte in ganz Norddeutschland'
    },
    {
      icon: Clock,
      number: '100%',
      label: 'Termingerecht',
      description: 'Pünktliche und zuverlässige Ausführung'
    },
    {
      icon: CheckCircle,
      number: '5 Jahre',
      label: 'Garantie',
      description: 'Vollumfängliche Gewährleistung auf alle Arbeiten'
    }
  ];

  return (
    <section id="about" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-center">
          {/* Content Section */}
          <div className="max-w-4xl text-center">
            <FadeIn delay={200}>
              <div className="mb-8">
                <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6 tracking-wide">
                  Über mich
                </h2>
                <div className="prose prose-lg text-stone-600 font-light leading-relaxed">
                  <p className="mb-6">
                    Mein Name ist <span className="font-medium text-stone-800">Jarek Jozwiak</span> und ich bin leidenschaftlicher Fliesenleger aus Cuxhaven. Seit über 20 Jahren verwandle ich Räume mit hochwertigen Fliesen und präziser Handwerkskunst.
                  </p>
                  <p className="mb-6">
                    Jedes Projekt ist für mich eine neue Herausforderung, bei der ich höchste Qualität und termingerechte Ausführung garantiere. Von der ersten Beratung bis zur finalen Reinigung stehe ich Ihnen persönlich zur Seite.
                  </p>
                </div>
                <a 
                  href="#contact"
                  className="inline-block bg-primary-600 text-white px-8 py-3 hover:bg-primary-700 transition-all duration-300 font-light tracking-wide"
                >
                  Persönliches Gespräch
                </a>
              </div>
            </FadeIn>
          </div>
        </div>

        {/* Statistics Grid */}
        <div className="mt-24">
          <FadeIn delay={400}>
            <div className="text-center mb-16">
              <h3 className="text-3xl font-light text-stone-800 mb-4">
                Vertrauen durch Expertise
              </h3>
              <p className="text-stone-600 font-light max-w-2xl mx-auto">
                Zahlen, die für sich sprechen und das Vertrauen meiner Kunden widerspiegeln
              </p>
            </div>
          </FadeIn>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <ScaleIn key={index} delay={600 + index * 150} duration={600}>
                  <div className="text-center bg-white p-8 hover:shadow-lg transition-shadow duration-300">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 text-primary-600 mb-6">
                      <Icon className="w-8 h-8" />
                    </div>
                    <div className="text-3xl font-light text-stone-800 mb-2">{stat.number}</div>
                    <div className="text-lg font-medium text-stone-800 mb-2">{stat.label}</div>
                    <p className="text-stone-600 text-sm font-light leading-relaxed">
                      {stat.description}
                    </p>
                  </div>
                </ScaleIn>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 